import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, NavigationEnd, RouterModule, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NotificationBannerComponent } from './shared/notification-banner/notification-banner.component';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AuthService } from './core/services/auth.service';
import { PermissionService } from './core/services/permission.service';
import { PERMISSION_LIST } from './core/constants/constants';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterModule, NotificationBannerComponent, RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
  private router = inject(Router);
  private authService = inject(AuthService);
  private permissionService = inject(PermissionService);
  private document = inject(DOCUMENT);
  private destroy$ = new Subject<void>();
  readonly PERMISSIONS = PERMISSION_LIST;

  currentLayout: 'main' | 'auth' = 'main';

  ngOnInit(): void {
    // Initialize with default permissions for boilerplate
    // In a real app, this would come from an auth service
    this.authService.checkTokenExpiration();

    // Listen to route changes to determine layout
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      let route = this.router.routerState.root;
      let layout = 'main';

      // Traverse the route tree to find layout data
      while (route.firstChild) {
        route = route.firstChild;
        const data = route.snapshot.data;
        if (data['layout']) {
          layout = data['layout'];
        }
      }

      this.currentLayout = layout as 'main' | 'auth';
    });

    // Set initial layout
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
      const data = route.snapshot.data;
      if (data['layout']) {
        this.currentLayout = data['layout'] as 'main' | 'auth';
      }
    }

    fromEvent<KeyboardEvent>(this.document, 'keydown')
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        if (this.permissionService.has(this.PERMISSIONS.SECURITY.ENABLE_CONTENT_COPY)) return;
        const key = event.key?.toLowerCase();
        const isSelectAll = key === 'a' || event.code === 'KeyA' || event.keyCode === 65;
        const isDevToolsShortcut =
          event.key === 'F12' ||
          event.code === 'F12' ||
          event.keyCode === 123 ||
          ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'c');

        if ((event.ctrlKey || event.metaKey) && isSelectAll) {
          event.preventDefault();
        }
        if (isDevToolsShortcut) {
          event.preventDefault();
        }
      });

    fromEvent<MouseEvent>(this.document, 'contextmenu')
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        if (this.permissionService.has(this.PERMISSIONS.SECURITY.ENABLE_CONTENT_COPY)) return;
        event.preventDefault();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
